import React, { createContext, ReactNode, useContext, useEffect } from 'react'
interface AuthProviderProps {
  children: ReactNode
}

interface IAuthContextData {
  token: string | null;
  userIsLogged: () => boolean;
}

const AuthContext = createContext({} as IAuthContextData)

function AuthProvider({ children }: AuthProviderProps) {
  const token = sessionStorage.getItem('token') || localStorage.getItem('ethosxAnalista:token')

  async function updatedToken() {
    const tokenLocal = await localStorage.getItem('ethosxAnalista:token')
    const tokenSession = await sessionStorage.getItem('token')

    if (!tokenSession && tokenLocal) {
      await sessionStorage.setItem('token', tokenLocal)
    }
  }

  function userIsLogged() {
    const tokenLocal = localStorage.getItem('ethosxAnalista:token')
    const tokenSession = sessionStorage.getItem('token')

    if (tokenLocal || tokenSession) {
      // if (!tokenSession && tokenLocal) {
      //   sessionStorage.setItem('token', tokenLocal)
      // }
      return true
    } else {
      return false
    }
  }

  useEffect(() => {
    updatedToken()
  }, [])

  return (
    <AuthContext.Provider value={{ userIsLogged, token }}>
      {children}
    </AuthContext.Provider>
  )
}

function useAuth() {
  const context = useContext(AuthContext)

  return context
}

export { AuthProvider, useAuth }